<div class="flex flex-col justify-center text-left gap-3 m-auto z-9998 h-14 mb-10 mt-5">

  <p class="w-full text-center">
    <button tabindex="101" (click)="onNext.emit()" [attr.aria-label]="buttonText" id="sub-navbar-next"
            class="bg-theme-yellow rounded-full inline-flex items-center justify-center pl-12 pr-12 pt-2 pb-2 my-1 cursor-pointer
          text-center text-xl font-bold text-theme-black font-theme-source border-4 border-theme-black
          disabled:opacity-75" [disabled]="!isValid">
      {{buttonText}}
    </button>
  </p>

</div>
